<div class="logo">
    <a href="#" class="simple-text">
        <div class="logo-img">
            <img *ngIf="isCollapsed" src="/assets/img/favicon1.png" alt="Favicon Logo" />
            <img *ngIf="!isCollapsed" src="/assets/img/pramat_logo.png" alt="Full Logo" />
        </div>
    </a>
</div>

<div class="sidebar-wrapper">
    <div *ngIf="isMobileMenu()">
        <form class="navbar-form">
            <span class="bmd-form-group">
                <div class="input-group no-border">
                    <input type="text" class="form-control" placeholder="Search...">
                    <button mat-raised-button type="submit" class="btn btn-white btn-round btn-just-icon">
                        <i class="material-icons">search</i>
                    </button>
                </div>
            </span>
        </form>
    </div>
    <ul class="nav">
        <li *ngFor="let menu of menuItems" [hidden]="!menu.access" class="nav-item"
            [ngClass]="{'active': menu.expanded}">
            <a href="javascript:void(0)" class="nav-link" (click)="menu.children ? toggleMenu(menu) : null"
                [routerLink]="menu.path ? [menu.path] : null">
                <i class="material-icons">{{menu.icon}}</i>
                <p>{{menu.title}}</p>
                <span *ngIf="menu.children" class="arrow">{{ menu.expanded ? '-' : '+' }}</span>
            </a>
            <ul *ngIf="menu.children && menu.expanded" class="nav child-menu">
                <li *ngFor="let child of menu.children" [hidden]="!child.access">
                    <a [routerLink]="child.path" class="nav-link">
                        <i class="material-icons">{{child.icon}}</i>
                        <p>{{child.title}}</p>
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</div>